import React from 'react';
import handleProviderProvider from 'mn-utils/changeProviderProviderSimple';
import withState from '../../../../utils/withState';
import Caption from '../../../dumb/Caption/B';
import Password from './components/Password';


module.exports = withState((setState) => {
  const handleProvider = handleProviderProvider(setState);
  const handleChangeStatePassword = handleProvider('statePassword');


  return (state) => {
    return (
      <div>
        {/*<div className="layoutRow fhaS fvaC">*/}
        {/*  <Caption>*/}
        {/*    Settings*/}
        {/*  </Caption>*/}
        {/*  /!*<div className="ml20 mv-10">*!/*/}
        {/*  /!*  {changed ? (<MessageNotSavedYet/>) : (*!/*/}
        {/*  /!*    saved ? (<MessageSaved/>) : null*!/*/}
        {/*  /!*  )}*!/*/}
        {/*  /!*</div>*!/*/}
        {/*</div>*/}

        {/*<Profile*/}
        {/*  className="mt26"*/}
        {/*  disabled={!isUserAccessed(PERMISSION_EDIT_BANK_DETAILS)}*/}
        {/*/>*/}

        {/*<div className="h1 mt80 mb40 bgDADCE1"/>*/}

        <Caption>
          Change password
        </Caption>
        <Password
          className="mt35"
          onChange={handleChangeStatePassword}
        />

        {/*<div className="h1 mt56 mb40 bgDADCE1"/>*/}

        {/*<Caption>*/}
        {/*  Notifications*/}
        {/*</Caption>*/}
        {/*<Notifications*/}
        {/*  className="mt35"*/}
        {/*  onChange={handleChangeStateNotifications}*/}
        {/*  disabled={!isUserAccessed(PERMISSION_NOTIFICATION_SETTINGS)}*/}
        {/*/>*/}

      </div>
    );
  };
});
